<section class="relative w-full max-w-full">
  <div class="relative w-full flex flex-col items-center overflow-hidden">
    <nav class="flex items-center w-full text-lWhite">

      @if (currentIndex > 0) {
        <div class="absolute left-0 flex items-center justify-center w-28 h-full bg-gradient-to-l from-transparent to-lBlack z-50">
          <button (click)="prev()">
            <l-icon class="text-lWhite !text-8xl">chevron_left</l-icon>
          </button>
        </div>
      }

      <div class="flex-1 overflow-hidden">
        <ul
          #track
          class="flex w-full transition-transform duration-300 list-none p-0 m-0"
          [style.transform]="'translateX(-' + (currentIndex * itemFullWidth) + 'px)'"
        >
          @for (item of items; track $index) {
            <li class="flex-shrink-0 px-2">
              <ng-container
                *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index: $index }">
              </ng-container>
            </li>
          }
        </ul>
      </div>

      @if (currentIndex < maxIndex) {
        <div class="absolute right-0 flex items-center justify-center w-28 h-full bg-gradient-to-r from-transparent to-lBlack z-50">
          <button (click)="next()">
            <l-icon class="text-lWhite !text-8xl">chevron_right</l-icon>
          </button>
        </div>
      }
    </nav>
  </div>
</section>